export default __webpack_public_path__ + "49e4e39.png";